const apiVersion = 'v1'
const baseUri = `/loy/api/bonus-points/${apiVersion}`;

export default {
    APP_NAME: 'bonus-points-web-components',
    COMPONENT_NAME: {
        FORECAST_BOX: 'forecast-box',
        ACCOUNT_NAVIGATION_BOX: 'account-navigation-box',
        REWARD_SHOP: 'reward-shop',
        MY_ZOOPLUS_BOX: 'my-zooplus-box',
        FORECAST_BOX_PREVIEW: 'forecast-box-preview',
        DONATIONS_PDP: 'donations-pdp',
        OVERVIEW: 'overview',
        LIGHT_ACCOUNT_NAVIGATION_BOX: 'light-account-navigation-box',
        PUBLIC_MENU: 'public-menu'
    },
    API: {
        TIMEOUT: 10000,
        URI: {
            LOGS: `${baseUri}/logs`,
            METRICS: `${baseUri}/metrics`,
            LOC_RESOURCES: `${baseUri}/loc-resources`,
            FORECAST: `${baseUri}/customers/balance-forecast`,
            ACCOUNT_NAVIGATION_BOX: `${baseUri}/customers`,
            MY_ZOOPLUS_BOX: `${baseUri}/customers`,
            REWARD_SHOP: `${baseUri}/reward-shop/overview`,
            BALANCE_PREVIEW: `${baseUri}/customers/balance-preview`,
            ENTRIES: `${baseUri}/customers/entries`,
            EXCHANGE_RATE: `${baseUri}/reward-shop/exchange-rate`
        },
        VARIABLE: {
            BALANCE: 'balance'
        }
    },
    EVENT: {
        AUTH: {
            SUCCESS: 'AUTH-SUCCESS-EVENT-v1'
        },
        CART: {
            ADD_TO_CART: 'ADD-TO-CART-v1',
            ADD_TO_CART_SUCCESS: 'ADD-TO-CART-SUCCESS-v1',
            ADD_TO_CART_FAILURE: 'ADD-TO-CART-FAILURE-v1',
            GET_CART: 'GET-CART-v1',
            GET_CART_SUCCESS: 'GET-CART-SUCCESS-v1',
            GET_CART_FAILURE: 'GET-CART-FAILURE-v1',
            UPDATE_ADOBE: 'UPDATE-ADOBE-v1'
        },
        BALANCE: {
            GET_BALANCE: 'GET-BALANCE-v1',
            GET_BALANCE_SUCCESS: 'GET-BALANCE-SUCCESS-v1',
            GET_BALANCE_FAILURE: 'GET-BALANCE-FAILURE-v1'
        },
        FORECAST_BOX: {
            ERROR: 'BONUS-POINTS-FORECAST-BOX-ERROR-v1'
        }
    }
}
